<template>
  <div>
    <h3>查看banner</h3>
    <el-form>
      <el-form-item label="Banner分类">
        <el-select
          v-model="model.bannerID"
          @change="getBanner"
          placeholder="选择分类"
        >
          <el-option
            v-for="item in bannerCate"
            :key="item.bannerID"
            :label="item.bannerType"
            :value="item.bannerID"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-table border :data="banner" style="width: 100%">
      <el-table-column prop="bannerName" label="banner名称"> </el-table-column>
      <el-table-column prop="bannerCate" label="所属分类" width="115">
        <template slot-scope="scope">
          <span v-for="tag in scope.row.bannerCate" :key="tag.index">
            <el-tag style="margin: 3px" v-show="tag.bannerType">{{
              tag.bannerType
            }}</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="bannerUrl" label="跳转链接"> </el-table-column>
      <el-table-column prop="bannerImg" width="480" label="图片">
        <template slot-scope="scope">
          <el-image
            style="width: 100%; height: 250px"
            :src="scope.row.bannerImg"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            style="margin: 3px 3px 3px 3px"
            @click="$router.push(`/banner/edit/${scope.row.id}`)"
            type="primary"
            icon="el-icon-edit"
            size="small"
            plain
            >编辑</el-button
          >
          <el-button
            style="margin: 3px 3px 3px 3px"
            @click="bannerDelete(scope.row)"
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--  grade分类分页 -->
    <div class="grade-page">
      <el-pagination
        @size-change="changeSize"
        @current-change="currentChange"
        :current-page="currentPage"
        @prev-click="bannerpre"
        @next-click="bannernext"
        background
        layout="prev, pager, next,total,jumper,sizes"
        :total="bannerLength"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banner: [],
      model: [],
      bannerCate: [],
      bannerLength: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  methods: {
    async getBanner() {
      try {
        const getbanner = await this.$http.get("/banner/list", {
          params: {
            bannerID: this.model.bannerID,
            page: this.currentPage,
            size: this.pageSize,
          },
        });

        this.banner = getbanner.data[0]?.result.map((item) => {
          return {
            bannerID: item.bannerID,
            bannerImg: "/" + item.bannerImg,
            bannerName: item.bannerName,
            id: item._id,
          };
        });
        this.bannerLength = getbanner.data[0]?.resultLength[0]?.totalCount;
      } catch (error) {
        console.log(error);
      }
    },
    async getBannerCate() {
      try {
        const result = await this.$http.get("/bannercate/getbannercate");
        this.bannerCate = result.data;
      } catch (error) {
        console.log(error);
      }
    },
    //删除grade
    async bannerDelete(row) {
      console.log(row.id);

      this.$confirm("此操作将永久删除且不能恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "waring",
        center: true,
      })
        .then(async () => {
          const res = await this.$http.get("/banner/delete?_id=" + `${row.id}`);
          if (res.status === 203) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.getBanner();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
      /* const pricemsg = await this.$http.get(
        "/category/deleteprice?_id=" + `${id}`
      ); */
    },
    //banner分类分页
    async bannerpre() {
      this.currentPage--;

      //this.getTertiary(this.pageSize);
      //console.log("上一页");
    },
    async bannernext() {
      this.currentPage++;
      // this.getTertiary(this.pageSize);
      //console.log(this.pageSize);
    },
    async changeSize(size) {
      this.pageSize = size;
    },
    async currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getBanner(this.currentPage);
      //console.log(this.currentPage);
    },
  },
  created() {
    this.getBanner();
    this.getBannerCate();
  },
};
</script>

<style scoped></style>
